<template>
  <section>
    <Popup v-model="showPopup" popup-header="Something went wrong" @close="closePopup">
      <p class="text-body mb-16">
        There was an error with processing your request. Try again or contact us if the issue continues.
      </p>
      <Button value="Try again" size="medium" class="w-full" @click="retrySubmit" />
    </Popup>
  </section>
</template>

<script lang="ts">
// components
import Popup from '../../../../components/popup/Popup.vue';
import Button from '../../../../components/button/Button.vue';

export default {
  name: 'ReviewError',
  components: { Popup, Button },
  props: {
    adventureStatus: {
      type: String,
      default: 'error',
    },
  },
  emits: ['close', 'click'],
  data(): any {
    return {
      showPopup: true,
    };
  },
  mounted() {
    this.checkAdventureStatus();
  },
  methods: {
    checkAdventureStatus(): any {
      if (this.adventureStatus === 'error') this.showPopup = true;
    },
    closePopup(): any {
      this.$emit('close');
      this.showPopup = false;
    },
    retrySubmit(): any {
      this.$emit('click');
      this.showPopup = false;
    },
  },
};
</script>
